<template>
  <div class="white-bg common-container">
    <h2 class="public-title">文都文化</h2>
    <div class="wrap company-culture">
      <el-row>
        <el-col :span="24">
          <img class="culture-cover" src="@/assets/images/img/img_culture.jpg" alt="">
        </el-col>
      </el-row>
      <el-row>
        <el-col :md="6" :sm="6" :xs="12" v-for="(item,index) in culture" :key="index">
          <div class="culture-list">
            <p class="culture-title">{{item.name}}</p>
            <p class="culture-detail">{{item.detail}}</p>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script >
import { defineComponent, ref, reactive } from "vue";
export default defineComponent({
  setup() {
    //文都文化
    const culture = reactive([
      {
        name: "文都使命",
        detail: "教育让生命更美好"
      },
      {
        name: "文都理念",
        detail: "崇尚荣誉 追求卓越"
      },
      {
        name: "文都精神",
        detail: "专业 创新 合作 共享"
      },
      {
        name: "文都愿景",
        detail: "科技赋能教育 文都成就未来"
      }
    ]);
    return {
      culture
    };
  }
});
</script>

<style lang="scss" scoped type="text/scss">
.company-culture {
  background:#f4f8fb;
  text-align: center;
  .culture-cover {
    width: 100%;
  }
  .culture-list {
    display: inline-block;
    padding: 56px 0;
    text-align: left;
  }
  .culture-title {
    font-size: 24px;
    color: #1b1d1f;
    font-weight:bold;
    margin-bottom: 16px;
  }
  .culture-detail {
    font-size: 16px;
  }
}
</style>
